import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {PathService} from "./path.service";

@Injectable({
    providedIn: 'root'
})
export class LabelaryService {

    private readonly root;

    constructor(private http: HttpClient,
                private pathService: PathService) {
        this.root = `${this.pathService.apiRoot}/label`;
    }

    getLabel(zpl: string): Observable<Blob> {
        return this.http.post(this.root, {zpl: zpl}, {responseType: 'blob'});
    }
}

